import { BaseWalletConnect } from './client';
import type { WalletConnectConfig } from './types';

// Registry backend the SDK reads /connect/wallets from; a dApp overrides via `apiUrl`/`registryUrl`.
const TONPASS_API_URL = 'https://tonpass-wallet-api.tonpass.xyz';

export class TonPassConnect extends BaseWalletConnect {
  constructor(config: Omit<WalletConnectConfig, 'walletId'>) {
    super({ ...config, walletId: 'tonpass', apiUrl: config.apiUrl ?? TONPASS_API_URL });
  }
}
